<template lang="html">
  <div class="footer">
    <div class="footer-content">
      <a href="http://watermark.agency">
        <img src="../../assets/wmk.svg" alt="Watermark Agency" class="footer-logo">
      </a>

      <img src="../../assets/footer_flair.svg" alt="Marketing Remix" class="footer-flair">
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vars";
@import "../../assets/scss/mixins";

.footer {
  display: none;
  
  @media only screen and (min-width: 40rem) {
    display: block;
  }
}

.footer-content {
  position: relative;
  background: white;
  padding: 1rem;
  height: rem-calc(115);
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-logo {
  height: rem-calc(56);
}

.footer-flair {
  position: absolute;
  top: 0;
  height: 100%;
  right: 0;
  width: auto;
}
</style>
